import React from "react";
import "react-table-v6/react-table.css";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import {
    Icon,
    Grid,
    Button,
    Card,
    Image,
    GridColumn,
    Dropdown,
    Label,
    Modal,
    Form,
    Input,
    Dimmer,
    Loader
} from "semantic-ui-react";
import ButtonHandler from "../../ButtonHandler.jsx";
import processIcon from "../../../Images/process.png";
import config from "../../../config.js";
import excel from "../../../Images/excel_icon.png";
import CheckboxTable from "../../ControlPanelComponents/CheckboxView.jsx";
import {
    runWholeSaleAutomationScript,
    getWholeSaleAutomationScriptStatus,
    fetchTemplates,
    fetchUseraction,
    wsQpsWorkingUpload,
    getWorkingFiles,
    wholesaleQPSSplitFiles,
    getwholesalesplitStatus,
    getwholesaleqpssplittedFiles,
    processCreditNoteWholeSaleQPS,
    getWholesalDisbursementFormulas,
    sendWholesaleQPSWorkingFiles,
    sendWholesaleQPSCreditNoteFiles,
    getApprovedEmails,
    getWholesaleQPSWokingReleaseProcessStatus,
    downloadallDSEfiles,
    downloadallCreditNotefiles,
    sendApprovalEmailToPandG
} from '../../../actions/users_action';
import SemanticDatepicker from 'react-semantic-ui-datepickers';

var apiTimeout = null
class WholesaleQPS extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            automationStatus: 'Pending',
            initial: true,
            outputUrl: '',
            downloadEnable: false,
            templateId: "",
            distributors: [],
            selectedDistributor: '',
            formulaModalOpen: false,
            formulas: [],
            selectedTemplate: '',
            templates: [],
            automationSplitFiles: [],
            modalOpen: false,
            fileUploaded: false,
            fileName: '',
            currentFiles: [],
            uploadedFileNames: [],
            workingFiles: [],
            auditingSplit: [],
            nonAuditingSplit: [],
            formulasType: '',
            loaderStatus: false,
            selectedDist: {},
            disType: 'WholeSale',
            periodModalOpen: false,
            locationList: [],
            overallLocationPeriods: [],
            splittedFiles: [],
            selectedLocation: '',
            approvalModalOpen: false,
            approvedEmailData: [],
            releaseAlertMoalOpen: false,
            creditNoteReleaseAlertModalOpen: false
        };
    }

    async componentDidMount() {
        await this.props.fetchTemplates({
            onSuccess: (res) => {
                this.props.getWholeSaleAutomationScriptStatus(res.templates[res.templates.length - 1]['_id'], {
                    onSuccess: (res) => {
                        if (res.master.fileUploadStatus) {
                            if (res.master.fileUploadStatus == 'Completed') {
                                console.log(res.master, 'res')
                                this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl, initial: false })
                                // clearTimeout(apiTimeout)
                            }
                        }
                    },
                    onFailure: () => {

                    }
                })




                this.setState({ templates: res.templates, selectedTemplate: res.templates[res.templates.length - 1]['name'], templateId: res.templates[res.templates.length - 1]['_id'], fileTemplates: res.templates[res.templates.length - 1]['fileTemplates'] })
            },
            onFailure: () => {
            }
        })

    }

    start = () => {
        this.setState({
            automationStatus: 'Processing',
            initial: false
        })

        let data = {
            templateId: this.state.templateId
        }

        this.props.runWholeSaleAutomationScript(data, {
            onSuccess: () => {
                apiTimeout = setTimeout(this.loadData, 3000)
            },
            onFailure: () => {

            }
        })
    }

    loadData = () => {
        this.props.getWholeSaleAutomationScriptStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.master.fileUploadStatus) {
                    if (res.master.fileUploadStatus == 'Completed') {
                        this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl })
                        clearTimeout(apiTimeout)
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadData, 3000)
    }

    downloadfile = (url) => {
        window.open(url);
    }

    dropDownDistributorOnChange = (e, data) => {
        this.setState({ selectedDistributor: data.value })
    }

    formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${dd}-${mm}-${yyyy}`;
    };


    dropDownTemplateOnChange = async (e, data) => {

        data.options.map(async (d) => {
            if (d.value == data.value) {
                this.setState({ templateId: d.key })
                await this.props.fetchUseraction(
                    d.key,
                    {
                        onSuccess: (res) => {
                            this.setState({ distributors: res.users })
                        },
                        onFailure: () => { this.setState({ loading: false }) }
                    });

                await this.props.getWholeSaleAutomationScriptStatus(d.key, {
                    onSuccess: (res) => {
                        if (res.master.fileUploadStatus) {
                            if (res.master.fileUploadStatus == 'Completed') {
                                console.log(res.master, 'res')
                                this.setState({ automationStatus: res.master.fileUploadStatus, downloadEnable: true, outputUrl: res.master.finalOutputUrl, initial: false })
                                // clearTimeout(apiTimeout)
                            }
                        }
                    },
                    onFailure: () => {

                    }
                })

                await this.props.getWorkingFiles(d.key, 'wholesaleQPSDisbursement', {
                    onSuccess: (res) => {
                        console.log(res, 'response')
                        this.setState({ workingFiles: res.workingFiles })
                    },
                    onFailure: () => {

                    }
                })

                await this.props.getwholesaleqpssplittedFiles(d.key, {
                    onSuccess: (res) => {
                        this.setState({ splittedFiles: res.splittedFiles })
                    },
                    onFailure: () => {

                    }
                })
                // this.setState({loaderStatus:false})

            }
            else {
                this.setState({ downloadEnable: false, initial: true, automationStatus: 'Pending', locationList: [] })
            }
        })
        this.setState({ selectedTemplate: data.value })
    }



    closeuploadoption = () => {
    this.setState({ 
        modalOpen: false, 
        periodModalOpen: false,
        approvalModalOpen: false,
        releaseAlertMoalOpen: false,
        currentFiles: [], // Reset files
        uploadedFileNames: [], // Reset file names
        fileUploaded: false // Reset upload status
    })
}

    fileupload = (e) => {
        const files = Array.from(e.target.files); // Convert FileList to Array
        console.log(files, 'files')
        this.setState({
            currentFiles: files,
            fileUploaded: files.length > 0,
            uploadedFileNames: files.map(f => f.name) // Store actual file names
        })
    };

   

    uploadRawFile = async () => {
    this.setState({ loaderStatus: true })
    
    const totalFiles = this.state.currentFiles.length; // Store the count BEFORE clearing
    
    try {
        // Upload files sequentially
        for (let i = 0; i < this.state.currentFiles.length; i++) {
            const file = this.state.currentFiles[i];
            const fileName = file.name; // Use actual file name
            
            await new Promise((resolve, reject) => {
                this.props.wsQpsWorkingUpload(file, fileName, this.state.templateId, {
                    onSuccess: () => {
                        console.log(`File ${i + 1}/${totalFiles} uploaded: ${fileName}`)
                        resolve()
                    },
                    onFailure: () => {
                        reject(new Error(`Failed to upload ${fileName}`))
                    }
                })
            })
        }
        
        // After all uploads complete
        this.setState({ 
            modalOpen: false, 
            loaderStatus: false, 
            currentFiles: [], 
            uploadedFileNames: [],
            fileUploaded: false
        })
        
        alert(`${totalFiles} file(s) uploaded successfully`) // Use the stored count
        
        // Refresh the working files list
        this.props.getWorkingFiles(this.state.templateId, 'wholesaleQPSDisbursement', {
            onSuccess: (res) => {
                console.log(res, 'response')
                this.setState({ workingFiles: res.workingFiles })
            },
            onFailure: () => {}
        })
    } catch (error) {
        this.setState({ loaderStatus: false })
        alert(`Error uploading files: ${error.message}`)
    }
}



    uploadFile = async (fileName, type) => {
        console.log(type, 'type')
        this.setState({ fileName: fileName, fileType: type, modalOpen: true })

    }

    loadSplitData = () => {

        this.props.getwholesalesplitStatus(this.state.templateId, 'wholesaleQPSDisbursement', {
            onSuccess: (res) => {
                if (res.master.splitStatus) {
                    if (res.master.splitStatus == 'Completed') {
                        this.setState({ loaderStatus: false })
                        clearTimeout(apiTimeout)
                        this.props.getwholesaleqpssplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles })
                            },
                            onFailure: () => {

                            }
                        })
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadSplitData, 3000)
    }


    splitFiles = async () => {

        if (this.state.splittedFiles.length < 0) {
            alert('Split Already Done')
        }
        else if (this.state.workingFiles.length == 0) {
            alert("Please Upload Approved File for further Process")
        }
        else {
            let data = {
                templateId: this.state.templateId
            }
            this.setState({ loaderStatus: true })
            await this.props.wholesaleQPSSplitFiles(data, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.loadSplitData, 3000)
                }
            })
        }

    }

    siteData = (rowData, checkedValue) => {

        this.setState({ 'selectedDist': rowData })

    };

    sendedData = (rowData, row) => {
        this.setState({ 'selectedDist': rowData })
    };

    loadWoringReleaseData = () => {
        this.props.getWholesaleQPSWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.workingRelease) {
                    // console.log(res.result,'result check')
                    if (res.result.workingRelease == 'Completed') {
                        this.setState({ loaderStatus: false, releaseAlertMoalOpen: false })
                        clearTimeout(apiTimeout)
                        alert('Working Files Released Successfully.Please check mails')
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadWoringReleaseData, 3000)
    }

    releaseWorking = () => {
        if (this.state.selectedDist.length !== 0) {
            this.setState({ loaderStatus: true })

            let data = {
                selectedDist: this.state.selectedDist,
                templateId: this.state.templateId
            }

            this.props.sendWholesaleQPSWorkingFiles(data, {
                onSuccess: () => {
                    apiTimeout = setTimeout(this.loadWoringReleaseData, 3000)
                    // this.setState({ loaderStatus: false })
                    // 
                },
                onFailure: () => {

                }
            })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    loadProcessCreditNote = () => {
        this.props.getWholesaleQPSWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.creditNoteProcessStatus) {
                    if (res.result.creditNoteProcessStatus == 'Completed') {
                        // this.setState({ loaderStatus:false})
                        clearTimeout(apiTimeout)
                        alert('Credit Note Processed Successfully')
                        this.props.getwholesaleqpssplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles, loaderStatus: false })
                                // alert('Credit Note Process Done')
                            },
                            onFailure: () => {

                            }
                        })
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadProcessCreditNote, 3000)
    }

    processCreditNotes = () => {
        if (this.state.selectedDist.length !== 0) {
            if (this.state.selectedDist[0].dseClientUpdate != 'pending') {
                // this.setState({loaderStatus:true})
                this.props.processCreditNoteWholeSaleQPS(this.state.selectedDist, {
                    onSuccess: () => {

                        apiTimeout = setTimeout(this.loadProcessCreditNote, 3000)
                    },
                    onFailure: () => {
                    }
                })
            }
            else {
                alert("DSE File Process Not Yet Done")
            }
        }
        else {
            alert('Please Select Distributor')
        }
    }

    loadReleaseCreditNote = () => {
        this.props.getWholesaleQPSWokingReleaseProcessStatus(this.state.templateId, {
            onSuccess: (res) => {
                if (res.result.creditNoteRelease) {
                    if (res.result.creditNoteRelease == 'Completed') {
                        // this.setState({ loaderStatus:false})
                        clearTimeout(apiTimeout)
                        alert('Credit Note Released Successfully')
                        this.props.getwholesaleqpssplittedFiles(this.state.templateId, {
                            onSuccess: (res) => {
                                this.setState({ splittedFiles: res.splittedFiles, loaderStatus: false })
                                // alert('Credit Note Process Done')
                            },
                            onFailure: () => {

                            }
                        })
                    }
                }
            },
            onFailure: () => {

            }
        })
        apiTimeout = setTimeout(this.loadReleaseCreditNote, 3000)
    }

    releaseCreditNote = () => {
        if (Object.keys(this.state.selectedDist).length !== 0) {
            if (this.state.selectedDist.creditNoteStatus != 'pending') {
                this.setState({ loaderStatus: true })
                this.props.sendWholesaleQPSCreditNoteFiles(this.state.selectedDist, {
                    onSuccess: () => {
                        apiTimeout = setTimeout(this.loadReleaseCreditNote, 3000)
                    },
                    onFailure: () => {

                    }
                })
            }
            else {

            }

        }
        else {
            alert('Please Select Distributor')
        }
    }

    downloadApprovalEmails = () => {
        let data = {
            templateId: this.state.templateId,
            fileName: 'wholesale-approvalEmails'
        }
        this.props.getApprovedEmails(data, {
            onSuccess: (res) => {
                if (res.approvalData.length > 0) {
                    this.setState({ approvedEmailData: res.approvalData[0].result, approvalModalOpen: true })
                }
                else {
                    alert('No Data Found')
                }
            },
            onFailure: () => {

            }
        })
        // this.setState({approvalModalOpen:true})
    }

    closeFormulaModal = () => {
        this.setState({ formulaModalOpen: false, approvalModalOpen: false, releaseAlertMoalOpen: false, creditNoteReleaseAlertModalOpen: false })
    }

    showReleaseConfirmationAlert = () => {
        if (this.state.selectedDist.length) {
            this.setState({ releaseAlertMoalOpen: true })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    showCreditNoteReleaseConfirmationAlert = () => {
        if (this.state.selectedDist.length) {
            this.setState({ creditNoteReleaseAlertModalOpen: true })
        }
        else {
            alert('Please Select Distributor')
        }

    }

    downloadDseDetails = () => {
        this.setState({ loaderStatus: true })
        this.props.downloadallDSEfiles(this.state.templateId, 'wholesaleQPSDSE', {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
            }
        })
    }

    downloadCreditNoteDetails = () => {
        this.setState({ loaderStatus: true })
        this.props.downloadallCreditNotefiles(this.state.templateId, 'wholesaleQPSCreditNote', {
            onSuccess: () => {
                this.setState({ loaderStatus: false })
            },
            onFailure: () => {
                this.setState({ loaderStatus: false })
            }
        })
    }

    sendEmailforApproval = () => {
        this.setState({ loaderStatus: true })
        let data = {
            templateId: this.state.templateId,
            disType: "wholesaleqps"
        }
        this.props.sendApprovalEmailToPandG(data, {
            onSuccess: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            },
            onFailure: (res) => {
                alert(res.status)
                this.setState({ loaderStatus: false })
            }
        })
    }

    downloadAllWorkingFiles = () => {
    if (this.state.workingFiles.length > 0 && this.state.workingFiles[0].result) {
        this.state.workingFiles.forEach((res, index) => {
            setTimeout(() => {
                this.downloadfile( res.result[0]);
            }, index * 500); // Delay each download by 500ms to prevent browser blocking
        });
    } else {
        alert('No files available to download');
    }
}




    render() {

        var templateMonths = []

        this.state.templates.map((d) => {
            templateMonths.push({
                'key': d._id,
                'value': d.name,
                'text': d.name
            })
        })

        var overallLocationsData = []

        if (this.state.locationList.length > 0) {
            this.state.locationList.map((loc) => {
                overallLocationsData.push(
                    {
                        'key': loc.location,
                        'value': loc.location,
                        'text': loc.location
                    }
                )
            })
        }


        const auditing_split_columns = [
            {
                Header: "Site Name",
                accessor: "siteName",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.siteName}</span>;
                },
            },
            {
                Header: "Location",
                accessor: "location",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <span>{original.location}</span>;
                },
            },
            {
                Header: "WholeSale QPS Working",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down" style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile(original.fileUrl)}
                    />;
                },
            },
           
            {
                Header: "Credit Note",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <Icon name="arrow circle down"
                        disabled={original.creditNoteStatus == 'pending' ? true : false}
                        style={{ marginLeft: 45, cursor: 'pointer' }} color={'green'}
                        onClick={() => this.downloadfile( original.creditNoteUrl)}
                    />;
                },
            },
            {
                Header: "Files Release Status",
                accessor: "workingReleaseCheck",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.workingReleaseCheck && original.workingReleaseCheck == 'Completed' ? 'Completed' : "Pending"}</h4>;
                },
            },
            {
                Header: "Files Release Date",

                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.releasingDate}</h4>;
                },
            },
            {
                Header: "Working Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.working_count && original.working_count != undefined ? original.working_count : '-'}</h4>;
                },
            },
            {
                Header: "Credit Amount",
                style: { textAlign: "left", cursor: "pointer" },
                Cell: ({ row: { original } }) => {
                    return <h4>{original.credit_count && original.credit_count != undefined ? original.credit_count : "-"}</h4>;
                },
            },
        ];


        return (
            <div>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <Dimmer active={this.state.loaderStatus}>
                        <Loader size="massive">File Processing.....</Loader>
                    </Dimmer>
                </div>

                {/* <br /> */}
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div style={{ marginLeft: 10 }}>
                        <Dropdown placeholder='Select Template Month' search selection options={templateMonths}
                            onChange={this.dropDownTemplateOnChange}
                            value={this.state.selectedTemplate}
                        />
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.uploadFile('wholesaleqps-approvedFiles', 'wholesaleqps-approvedFiles')}
                        >

                            Upload Files for P&G Approval
                            <Icon name="upload" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.sendEmailforApproval()}
                        >

                            Send Email for P&G Approval
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                </div>



                <Grid columns={3} style={{ marginTop: 20 }}>


                    <GridColumn>
                        <Card.Group>
                            <h2 style={{ marginLeft: 20 }}>Approved Disbursement</h2>
                            <Card className="fluid" style={{ height: 200 }}>
                                <Card.Content>
                                    <Image
                                        floated='right'
                                        size='mini'
                                        src={excel}
                                        style={{ cursor: 'pointer' }}
                                    />
                                    <br></br>
                                    <br></br>
                                    <br></br>
                                    <Card.Description style={{ marginTop: 20 }}>
                                        <h3 style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>{'Approved File   '} <Icon name="upload" style={{ marginLeft: 65, cursor: 'pointer' }} color={'orange'}
                                            onClick={() => this.uploadFile('wholesaleQPSDisbursement', 'wholesaleQPSDisbursement')}
                                        /><Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color={'green'}
                                            onClick={() =>  this.downloadAllWorkingFiles()}
                                            /></h3>

                                    </Card.Description>

                                    <br></br>

                                </Card.Content>
                            </Card>
                        </Card.Group>
                    </GridColumn>
                </Grid>
                <br></br>
                <br></br>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    <div>
                        <p style={{ fontSize: 25 }}>
                            <h1
                                style={{

                                    flex: "0 0 30px",
                                    display: "inline-block",
                                    color: "#2185d0",
                                }}
                            >
                                Disbursement Working for Sites
                            </h1>
                        </p>
                    </div>

                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.splitFiles()}
                            disabled={true}
                        >

                            Split Files
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.showReleaseConfirmationAlert()}
                            disabled={true}
                        >

                            Release Workings & Credit Notes
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>
                    {/* <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.processCreditNotes()}
                            disabled={true}
                        >

                            Process CreditNote
                            <Icon name="file" style={{ marginLeft: 10 }} />
                        </Label>
                    </div> */}
                    {/* <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 15, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.showCreditNoteReleaseConfirmationAlert()}
                            disabled={true}
                        >

                            Release CreditNote
                            <Icon name="envelope" style={{ marginLeft: 10 }} />
                        </Label>
                    </div> */}
                    {/* <div>
                        <Label
                            style={{ justifyContent: 'flex-end',marginLeft: 10,marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.downloadDseDetails()}
                            disabled={true}
                        >

                             DSE
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div> */}
                    <div>
                        <Label
                            style={{ justifyContent: 'flex-end', marginLeft: 10, marginTop: 5, cursor: 'pointer' }}
                            size="large"
                            color="blue"
                            onClick={() => this.downloadCreditNoteDetails()}
                            disabled={true}
                        >

                            Credit Note
                            <Icon name="download" style={{ marginLeft: 10 }} />
                        </Label>
                    </div>

                </div>


                <p style={{ fontSize: 18 }}>
                    <h1
                        style={{

                            flex: "0 0 30px",
                            display: "inline-block",
                            color: "#0000000",
                        }}
                    >
                        Site Wise Files
                    </h1>
                </p>
                <CheckboxTable
                    data={this.state.splittedFiles}
                    columns={auditing_split_columns}
                    sendedData={this.siteData}
                />
                <br></br>
                <br></br>



                <Modal
                    open={this.state.modalOpen}
                    onClose={this.closeuploadoption}
                    size="mini"
                >
                    <Modal.Content>
                        <Form>
                            <Grid columns={1}>
                                <Grid.Row>
                                    <Grid.Column style={{ marginTop: 20 }}>
                                        <h4>Upload Master data :</h4>
                                        <Input
                                            type="file"
                                            accept=".xlsx"
                                            onChange={this.fileupload}
                                            multiple // This enables multiple file selection
                                        />
                                        {this.state.uploadedFileNames.length > 0 && (
                                            <div style={{ marginTop: 10 }}>
                                                <h5>Selected Files ({this.state.uploadedFileNames.length}):</h5>
                                                <ul>
                                                    {this.state.uploadedFileNames.map((name, idx) => (
                                                        <li key={idx}>{name}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.uploadRawFile}
                                title={`Upload ${this.state.currentFiles.length} File(s)`}
                                color={'green'}
                                iconColor={'white'}
                                disabled={!this.state.fileUploaded}
                            />
                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>
                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Uploading Files...</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.approvalModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            {this.state.approvedEmailData.length > 0 && this.state.approvedEmailData.map((d) => {
                                return (
                                    <>
                                        <h3>{d.fileName} :  <Icon name="arrow circle down" style={{ marginLeft: 25, cursor: 'pointer' }} color='green' onClick={() => this.downloadfile( d.fileUrl)} /></h3>
                                    </>
                                )
                            })}



                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>

                            <ButtonHandler
                                click={this.closeuploadoption}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                </Modal>
                <Modal
                    open={this.state.releaseAlertMoalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h1><b>Below Sites You're Choosing for Working Files Release Process </b></h1>
                            {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d, index) => {
                                return (
                                    <>
                                        <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                    </>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.releaseWorking}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
                <Modal
                    open={this.state.creditNoteReleaseAlertModalOpen}
                    onClose={this.closeFormulaModal}
                    size="normal"
                >
                    <Modal.Content>
                        <Form>
                            <h1><b>Below Sites You're Choosing for Credit Note Release Process </b></h1>
                            {this.state.selectedDist.length > 0 && this.state.selectedDist.map((d, index) => {
                                return (
                                    <>
                                        <h3>{index + 1}{'. '}{d.siteName}-{d.location}</h3>
                                    </>
                                )
                            })}
                        </Form>
                    </Modal.Content>

                    <Modal.Actions>
                        <div style={{ display: 'flex', flexDirection: "row", justifyContent: "flex-end" }}>
                            <ButtonHandler
                                click={this.releaseCreditNote}
                                isIcon={true}
                                color={'green'}
                                iconName={'mail'}
                                iconColor={'white'}
                                title={'Send'}
                            />
                            <ButtonHandler
                                click={this.closeFormulaModal}
                                isIcon={true}
                                color={'red'}
                                iconName={'remove'}
                                iconColor={'white'}
                                title={'Close'}
                            />
                        </div>

                    </Modal.Actions>
                    {this.state.loaderStatus && (
                        <Dimmer active inverted>
                            <Loader inverted>Loading</Loader>
                        </Dimmer>
                    )}
                </Modal>
            </div>

        )

    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth,
        user: state.user,
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
        {
            runWholeSaleAutomationScript,
            getWholeSaleAutomationScriptStatus,
            fetchTemplates,
            fetchUseraction,
            wsQpsWorkingUpload,
            getWorkingFiles,
            wholesaleQPSSplitFiles,
            getwholesalesplitStatus,
            getwholesaleqpssplittedFiles,
            processCreditNoteWholeSaleQPS,
            getWholesalDisbursementFormulas,
            sendWholesaleQPSWorkingFiles,
            sendWholesaleQPSCreditNoteFiles,
            getApprovedEmails,
            getWholesaleQPSWokingReleaseProcessStatus,
            downloadallDSEfiles,
            downloadallCreditNotefiles,
            sendApprovalEmailToPandG
        },
        dispatch
    );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WholesaleQPS));
